import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { useFetcher } from '@/api/useGetFetchConfig';
import { ThreadMessage } from '@/types';

export const useGetMessages = (matterId: string, subsetId: string, threadId: string) => {
  const fetcher = useFetcher();

  return useQuery<ThreadMessage[]>(
    [QueryEntity.Messages, { threadId }],
    () => fetcher(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/thread/${threadId}/messages`),
    {
      enabled: !!matterId && !!subsetId && !!threadId,
      refetchOnWindowFocus: false,
    },
  );
};
